import { Chip } from '@mui/material';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import type { NotificationCategory } from '@/notifications';

interface NotificationCategoryChipProps {
  category: NotificationCategory;
}

const categoryLabelKeys: Record<NotificationCategory, string> = {
  all: 'notificationCenter.category.all',
  application: 'notificationCenter.category.application',
  audit: 'notificationCenter.category.audit',
  featureFlags: 'notificationCenter.category.featureFlags',
  security: 'notificationCenter.category.security',
  system: 'notificationCenter.category.system',
  userActivity: 'notificationCenter.category.userActivity',
};

export const NotificationCategoryChip = memo(function NotificationCategoryChip({
  category,
}: NotificationCategoryChipProps) {
  const { t } = useTranslation('entity-portal');

  return (
    <Chip
      size="small"
      variant="outlined"
      label={t(categoryLabelKeys[category])}
      sx={{}}
    />
  );
});
